import React from 'react';
import { modelInfo } from '../data/mock';

const About = () => {
  const stats = [
    { label: 'Height', value: modelInfo.height },
    { label: 'Hair', value: modelInfo.hair },
    { label: 'Eyes', value: modelInfo.eyes }
  ];

  return (
    <section id="about" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Image */}
          <div className="relative">
            <div className="aspect-[3/4] overflow-hidden">
              <img
                src="/portfolio/GC6A2255__-2.jpg"
                alt={modelInfo.name}
                className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700"
              />
            </div>
            {/* Decorative Elements */}
            <div className="absolute -bottom-6 -right-6 w-full h-full border border-black/10 -z-10" />
          </div>

          {/* Content */}
          <div>
            <span className="font-poppins text-xs tracking-[0.4em] text-gray-400 mb-4 block">
              ABOUT
            </span>
            <h2 className="font-bebas text-5xl md:text-6xl tracking-wider mb-8">
              {modelInfo.name}
            </h2>
            
            <div className="space-y-6 mb-12">
              {modelInfo.bio.split('\n\n').map((paragraph, index) => (
                <p
                  key={index}
                  className="font-poppins text-gray-600 leading-relaxed text-sm md:text-base"
                >
                  {paragraph}
                </p>
              ))}
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-8 pt-8 border-t border-gray-200">
              {stats.map((stat) => (
                <div key={stat.label}>
                  <span className="font-poppins text-xs tracking-wider text-gray-400 block mb-2">
                    {stat.label}
                  </span>
                  <span className="font-bebas text-xl tracking-wide">
                    {stat.value}
                  </span>
                </div>
              ))}
            </div>

            {/* Location */}
            <div className="mt-8 pt-8 border-t border-gray-200">
              <span className="font-poppins text-xs tracking-wider text-gray-400 block mb-2">
                Based In
              </span>
              <span className="font-bebas text-xl tracking-wide">
                {modelInfo.location}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
